module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10065.ea3cb756.jpg";